import asherPic from "@/public/images/artists/asher.png";
import { Artist } from "@/types/types";

export const asher = {
  id: "195",
  name: "Asher",
  image: asherPic,
  description: `Asher's voice carries a youthful warmth with a rich vibrato that adds depth to his sound. His tone is expressive and clear, making him just as compelling on stripped-down acoustic tracks as he is on soaring pop anthems.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fasher-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Unprocessed", "Belting", "Indie"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 48,
        high: 72,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
